import React from "react";
import { Controller } from "react-hook-form";
import FileUploader from "./FileUploader";
import handleErrorMsg from "../helper/handleErrorMsg";
import useTranslation from "next-translate/useTranslation";
import isPlainObject from "lodash.isplainobject";

export default function UploaderController({
  name,
  control,
  rules,
  max = 4,
  defaultValue = [],
  single = false,
  otherSx,
  additionalStyles,
  ...otherProps
}) {
  const { t } = useTranslation("common-locale");

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { ref, value, onChange, ...otherRenderProps },
        fieldState: { error },
      }) => {
        let errors = {};

        if (isPlainObject(error)) {
          if (error.message !== undefined && error.type !== undefined) {
            errors[0] = handleErrorMsg(error, t);
          } else {
            Object.keys(error).forEach((errKey) => {
              errors[errKey] = handleErrorMsg(error[errKey], t);
            });
          }
        }
        return (
          <FileUploader
            ref={ref}
            errors={errors}
            files={value}
            max={max}
            onChange={onChange}
            single={single}
            error={value?.length === 0 && errors[0]}
            helperText={value?.length === 0 && errors[0]}
            otherSx={otherSx}
            additionalStyles={additionalStyles}
            {...otherProps}
            {...otherRenderProps}
          />
        );
      }}
      defaultValue={defaultValue}
    />
  );
}
